import React, { forwardRef, useCallback, useMemo } from 'react'
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import AmazonInspectorMappingForm from './AmazonInspectorMappingForm';
import { Alert, Button } from 'antd';
import { generateUUID } from "utils/uuid";
import useEnvironmentVariables from "hooks/useEnvironmentVariables"
function AmazonInspectorCredentialsForm(props, ref) {
    const  AMAZON_INSPECTOR_ARMORCODE_ACCOUNT_ID = useEnvironmentVariables('REACT_APP_AMAZON_INSPECTOR_ARMORCODE_ACCOUNT_ID');
    const onIAMClick = useCallback(() => {
        const externalId = generateUUID();
        window.open(`https://us-west-2.console.aws.amazon.com/cloudformation/home?region=us-west-2#/stacks/quickcreate?stackName=ArmorCodeInspector2Stack&templateURL=https://armorcode.s3.us-west-2.amazonaws.com/ArmorCodeAWSInspectorRole.yml&param_ExternalId=${externalId}&param_AccountId=${AMAZON_INSPECTOR_ARMORCODE_ACCOUNT_ID}`, "_blank", "width=1000,height=800,rel=noopener")
    }, [AMAZON_INSPECTOR_ARMORCODE_ACCOUNT_ID])

    const prependFields = useMemo(() => [{
        render: () => ( 
            <Alert
                type="warning"
                className='m-b-xs'
                description={'Click on Create IAM Role button to create a role in your AWS account which will allow us to pull the findings. Using CloudFormation, we will create the necessary role. After the stack completes, please navigate to outputs section and copy External ID , Role ARN and paste it in below fields.'} 
            /> 
        ),
    }, {
        render: () => <Button className='m-t-xs m-b-xs' type="primary" onClick={onIAMClick}>Create IAM Role</Button>
    }], [onIAMClick])

    const fields = useMemo(() => [
        {
            name: "roleARN",
            label: "Role ARN",
            required: true,
        },
        {
            name: "externalId",
            label: "External ID",
            required: true,
        }
    ], []);

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            prependFields={prependFields}
            MappingForm={AmazonInspectorMappingForm}
        />
    )
}

export default forwardRef(AmazonInspectorCredentialsForm);